import { trackAddToCart, trackRemoveFromCart } from "../../utils/analytics";
import { toast } from "react-toastify";
import { syncCartToBackend, trackCartEvent } from "../../utils/cartSync";

export const LOAD_CART = "LOAD_CART";
export const ADD_CART = "ADD_CART";
export const REMOVE_CART = "REMOVE_CART";
export const DEC_CART = "DEC_CART";
export const INC_CART = "INC_CART";
export const UPDATE_CART_QUANTITY = "UPDATE_CART_QUANTITY";
export const EMPTY_CART = "EMPTY_CART";

export const emptyCart = () => {
  return async (dispatch, getState) => {
    dispatch({ type: EMPTY_CART });

    // Sync empty cart to backend
    const state = getState();
    const customer = state.customer.customer;
    await syncCartToBackend([], customer);
  };
};

export const updateCartQuantity = ({ id }, quantity) => {
  return async (dispatch, getState) => {
    const state = getState();
    const item = state.cart.items.find((cartItem) => cartItem.id === id);

    if (!item) {
      return;
    }

    // Minimum miktar kontrolü
    if (quantity < 1) {
      quantity = 1;
    }

    // Stok kontrolü - maksimum stok kadar eklenebilir
    // stock bilgisi varsa ve pozitif bir sayıysa kontrol yap
    if (item.stock && item.stock > 0 && quantity > item.stock) {
      toast.warning(
        "Bu urunden en fazla " + item.stock + " adet sepete ekleyebilirsiniz."
      );
      // Maksimum stok kadar ayarla
      quantity = item.stock;
    }

    dispatch({ type: UPDATE_CART_QUANTITY, payload: { id, quantity } });

    // Sync to backend after update
    const updatedState = getState();
    const customer = updatedState.customer.customer;
    await syncCartToBackend(updatedState.cart.items, customer);
    await trackCartEvent("update", id, quantity);
  };
};

export const incCart = ({ id }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const item = state.cart.items.find((cartItem) => cartItem.id === id);

    if (!item) {
      return;
    }

    // Stok kontrolü - mevcut miktar + 1, stoktan fazla olamaz
    // stock bilgisi varsa ve pozitif bir sayıysa kontrol yap
    if (item.stock && item.stock > 0 && item.quantity + 1 > item.stock) {
      toast.warning(
        "Bu urunden en fazla " + item.stock + " adet sepete ekleyebilirsiniz."
      );
      return;
    }

    dispatch({ type: INC_CART, payload: id });

    // Sync to backend after increment
    const updatedState = getState();
    const customer = updatedState.customer.customer;
    await syncCartToBackend(updatedState.cart.items, customer);
    await trackCartEvent("update", id, item.quantity + 1);
  };
};
export const decCart = ({ id }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const item = state.cart.items.find((cartItem) => cartItem.id === id);

    dispatch({ type: DEC_CART, payload: id });

    // Sync to backend after decrement
    const updatedState = getState();
    const customer = updatedState.customer.customer;
    const newQuantity = item ? item.quantity - 1 : 0;
    await syncCartToBackend(updatedState.cart.items, customer);
    await trackCartEvent("update", id, newQuantity);
  };
};

export const removeCart = (item) => {
  return async (dispatch, getState) => {
    const state = getState();
    const cartItem = state.cart.items.find(
      (cartEntry) => cartEntry.id === item.id
    );

    if (cartItem) {
      trackRemoveFromCart(cartItem, cartItem.quantity);
    }

    dispatch({ type: REMOVE_CART, payload: item.id });

    // Sync to backend after removal
    const updatedState = getState();
    const customer = updatedState.customer.customer;
    await syncCartToBackend(updatedState.cart.items, customer);
    await trackCartEvent("remove", item.id);
  };
};

export const loadCart = () => {
  return async (dispatch, getState) => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    dispatch({ type: LOAD_CART, payload: cart });

    // Sync to backend to get updated prices
    if (cart.length > 0) {
      const state = getState();
      const customer = state.customer.customer;
      await syncCartToBackend(cart, customer);
    }
  };
};

export const addCart = (product, quantity) => {
  return async (dispatch, getState) => {
    const state = getState();
    const existingItem = state.cart.items.find(
      (item) => item.id === product.id
    );
    const currentQuantity = existingItem ? existingItem.quantity : 0;
    const requestedTotal = currentQuantity + quantity;

    // Stok kontrolü - ürün stokta yok mu?
    if (!product.stock || product.stock === 0) {
      toast.error("Bu urun stokta bulunmamaktadir.");
      return;
    }

    // Stok kontrolü - toplam miktar stoktan fazla olamaz
    if (product.stock && requestedTotal > product.stock) {
      if (currentQuantity > 0) {
        toast.warning(
          "Bu urunden en fazla " +
            product.stock +
            " adet sepete ekleyebilirsiniz. Sepetinizde " +
            currentQuantity +
            " adet var."
        );
      } else {
        toast.warning(
          "Bu urunden en fazla " +
            product.stock +
            " adet sepete ekleyebilirsiniz."
        );
      }
      return;
    }

    trackAddToCart(product, quantity);
    dispatch({ type: ADD_CART, payload: { product, quantity } });

    // Sync to backend after adding
    const updatedState = getState();
    const customer = updatedState.customer.customer;
    await syncCartToBackend(updatedState.cart.items, customer);
    await trackCartEvent("add", product.id, quantity);
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/cart.js